module.exports = __webpack_public_path__ + "img/datasmartylogo.01943ac4.svg";